import type { State } from '../types.js';

export function getCurrentUserEmail(state: State): string | undefined {
  return state.username;
}
